var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 209,
    viewBox: "0 0 211 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.488 16.705C122.48 16.7427 139.048 24.8062 153.862 35.0354C169.008 45.4944 183.089 58.1699 189.534 75.4308C196.153 93.1593 195.576 112.86 189.627 130.825C183.704 148.713 171.871 163.96 156.584 174.943C141.366 185.876 123.204 192.615 104.488 191.993C86.1598 191.383 69.4756 182.637 54.8462 171.56C40.4534 160.662 28.5091 146.838 22.3972 129.833C16.1432 112.433 14.4133 93.237 20.4091 75.7456C26.3464 58.4249 39.994 45.3396 54.9637 34.8278C69.7162 24.4685 86.4722 16.6671 104.488 16.705Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.32 2.00016C125.292 2.04427 144.604 11.4603 161.871 23.4054C179.526 35.6188 195.938 50.4205 203.45 70.5768C211.166 91.2791 210.492 114.284 203.558 135.263C196.655 156.152 182.863 173.956 165.043 186.782C147.305 199.549 126.136 207.418 104.32 206.691C82.9567 205.98 63.5096 195.766 46.4575 182.831C29.6812 170.104 15.7588 153.962 8.63477 134.105C1.34512 113.785 -0.67126 91.3698 6.31748 70.9444C13.238 50.7183 29.1457 35.438 46.5944 23.1629C63.7901 11.0659 83.3209 1.95599 104.32 2.00016Z",
    stroke: "#8C8C8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.1 15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.548 73.7448C148.787 71.3021 148.622 67.5067 146.18 65.2675C143.737 63.0284 139.942 63.1934 137.702 65.6361L108.329 97.6804L78.9547 65.6361C76.7156 63.1934 72.9202 63.0284 70.4774 65.2675C68.0347 67.5067 67.8697 71.3021 70.1089 73.7448L100.189 106.56L70.1074 139.376C67.8682 141.819 68.0332 145.614 70.476 147.853C72.9187 150.093 76.7141 149.928 78.9532 147.485L108.329 115.439L137.704 147.485C139.943 149.928 143.739 150.093 146.181 147.853C148.624 145.614 148.789 141.819 146.55 139.376L116.468 106.56L146.548 73.7448Z",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.e15b4e987aa11c5ca7726449909780ec.svg";
export { ForwardRef as ReactComponent };